import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/problemSyphilis/problemSyphilisData.json";

export default function ProblemSyphilis() {
  useSEO(seoConfig.problemSyphilis);

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Консультативный совет по проблеме «Сифилис»
      </h1>

      <Accordion data={data} />
    </section>
  );
}
